import React, {Component} from "react"
import styles from "./Footer.module.css"
import naaLogo from "../Header/parts/img/salemu-logo.png"

const campuses = [
    {
        id: 1,
        region_id: 1,
        name: "Virginia",
        code: "Virginia",
        address: "223 West Main Street Salem, WV 26426",
        state: "",
        phone: "(844) 462-9128",
        school_code: "",
        region: {
            id: 1,
            state: "Virginia",
            region: "Virginia"
        }
    }
]

const social = [
    {
        id: 1,
        name: "Facebook",
        link: "https://www.facebook.com/SALEM.EDU",
        icon: "fa fa-facebook"
    },
    {
        id: 2,
        name: "Instagram",
        link: "https://instagram.com/naaedu",
        icon: "fa fa-instagram"
    },
    {
        id: 3,
        name: "Twitter",
        link: "https://twitter.com/naaedu",
        icon: "fa fa-twitter"
    },
    {
        id: 4,
        name: "Youtube",
        link: "https://www.youtube.com/naaedu",
        icon: "fa fa-youtube-play"
    }
]

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div>
                        <div>
                            <img src={naaLogo} alt="salemu-logo" className={styles.logo} />
                        </div>
                        <div className={styles.social}>
                            {social.map(({id, link, icon}) => (
                                <a
                                    href={link}
                                    className={icon}
                                    key={id}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {""}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.campuses}>
                        <h5>
                            <strong>CAMPUS LOCATION</strong>
                        </h5>
                        {campuses.map(({code, address, phone, id}) => (
                            <div className={styles.campusContainer} key={id}>
                                <div className={styles.code}>
                                    <strong>{code}</strong>
                                </div>
                                <div className={styles.address}>{address}</div>
                                <div className={styles.phone}>
                                    <strong>Ph:</strong> {phone}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </footer>
        )
    }
}
